import EditIcon from '@mui/icons-material/Edit';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

import { useCategories, useRenameCategory } from '../../api/queries';

export default function AdminCategories() {
  const { data, isLoading, error } = useCategories();
  const rename = useRenameCategory();
  const { enqueueSnackbar } = useSnackbar();
  const [renaming, setRenaming] = useState<string | null>(null);
  const [newName, setNewName] = useState('');

  if (isLoading) return <CircularProgress />;
  if (error) return <Alert severity="error">Failed: {String(error)}</Alert>;

  const submit = async () => {
    if (!renaming || !newName.trim()) return;
    try {
      await rename.mutateAsync({ oldName: renaming, newName: newName.trim() });
      enqueueSnackbar(`Renamed ${renaming} → ${newName.trim()}`, { variant: 'success' });
      setRenaming(null);
      setNewName('');
    } catch (err) {
      enqueueSnackbar(`Rename failed: ${err instanceof Error ? err.message : err}`, {
        variant: 'error',
      });
    }
  };

  return (
    <Stack spacing={2}>
      <Table size="small" className="max-w-xl">
        <TableHead>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell align="right">Apps</TableCell>
            <TableCell align="right" />
          </TableRow>
        </TableHead>
        <TableBody>
          {(data ?? []).map((c) => (
            <TableRow key={c.category} hover>
              <TableCell>{c.category}</TableCell>
              <TableCell align="right">{c.app_count}</TableCell>
              <TableCell align="right">
                <IconButton
                  size="small"
                  onClick={() => {
                    setRenaming(c.category);
                    setNewName(c.category);
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Dialog open={!!renaming} onClose={() => setRenaming(null)} maxWidth="xs" fullWidth>
        <DialogTitle>Rename category — {renaming}</DialogTitle>
        <DialogContent>
          <TextField
            label="New name"
            size="small"
            fullWidth
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            className="mt-2"
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRenaming(null)}>Cancel</Button>
          <Button variant="contained" onClick={submit} disabled={rename.isPending}>
            Rename
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}
